import React, { useCallback, useState, useEffect, useMemo } from 'react';
import { MdOutlineAlternateEmail, MdPhoneAndroid } from 'react-icons/md';
import { BiUserCircle } from 'react-icons/bi';

import { phoneMask } from 'utils/functions';
import ModalAlterPassword from './ModalAlterPassword';

import { useSetValuesProfile } from '../hooks/useSetValuesProfile';

import { Container, Button, ModalComponent } from './styles';
import { Box, BootstrapForm, InputText } from '../styles';
import { TypeModalProps } from '../types';

type FormUserProps = {
  id?: string;
};

const FormUser: React.FC<FormUserProps> = ({ id = '' }) => {
  const [showModalAlterPassword, setShowModalAlterPassword] =
    useState<boolean>(false);
  const [typeModal, setTypeModal] = useState<TypeModalProps>('alter');

  const { email, emailSF, nameSF, phoneSF } = useSetValuesProfile();

  useEffect(() => {
    setShowModalAlterPassword(false);
    setTypeModal('alter');
  }, []);

  const handleTypeModal = useCallback((typeModalParam: TypeModalProps) => {
    setTypeModal(typeModalParam);
  }, []);

  const phoneCustom = useMemo(() => {
    return phoneMask(phoneSF);
  }, [phoneSF]);

  return (
    <Container id={id}>
      <Box>
        <BootstrapForm.Group controlId="name">
          <InputText
            type="text"
            label="Nome:"
            ariaLabel="Nome:"
            ariaRequired
            title="Nome:"
            placeholder="Nome:"
            value={nameSF}
            disabled
            LeadingIcon={() => <BiUserCircle size={24} color="#7a7a7a" />}
          />
        </BootstrapForm.Group>
        <div
          style={{
            marginTop: '8px',
          }}
        />
        <BootstrapForm.Group controlId="phone">
          <InputText
            type="text"
            label="Celular:"
            ariaLabel="Celular:"
            ariaRequired
            title="Celular:"
            placeholder="Celular:"
            value={phoneCustom}
            disabled
            LeadingIcon={() => <MdPhoneAndroid size={24} color="#7a7a7a" />}
          />
        </BootstrapForm.Group>
        <div
          style={{
            marginTop: '8px',
          }}
        />
        <BootstrapForm.Group controlId="email">
          <InputText
            type="text"
            label="Email:"
            ariaLabel="Email:"
            ariaRequired
            title="Email:"
            placeholder="Email:"
            value={emailSF || email}
            disabled
            LeadingIcon={() => (
              <MdOutlineAlternateEmail size={24} color="#7a7a7a" />
            )}
          />
        </BootstrapForm.Group>
      </Box>
      <Box>
        <BootstrapForm.Group controlId="buttonSend">
          <Button width="221px" onClick={() => setShowModalAlterPassword(true)}>
            Alterar senha
          </Button>
        </BootstrapForm.Group>
      </Box>
      <ModalComponent
        typeModal={typeModal}
        show={showModalAlterPassword}
        onHide={() => setShowModalAlterPassword(false)}
        size="lg"
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
        animation={false}
      >
        <ModalAlterPassword
          cancelAlterPassword={() => setShowModalAlterPassword(false)}
          setTypeModal={handleTypeModal}
        />
      </ModalComponent>
    </Container>
  );
};

FormUser.defaultProps = {
  id: '',
};

export default FormUser;
